import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Container, Row, Col, Tabs, Tab, Form, Button, Table, Pagination, InputGroup, Modal, Spinner, OverlayTrigger, Tooltip, Dropdown
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTag, faCircleInfo, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import PatientReassignmentModal from './PatientReassignmentModal';
import { LIMIT, STATUS } from '../lib/utils/constant';
import FilterDropdown from './FilterDropdown';

// --- SVG Icons ---
const PlusCircleIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" /><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" /></svg>);
const SearchIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" /></svg>);
const PencilSquareIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" /><path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" /></svg>);
const TrashIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" /><path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" /></svg>);
const GearIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" /><path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" /></svg>);
const PersonXIcon = ({ className = '' }) => (<svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" /><path fillRule="evenodd" d="M12.146 5.146a.5.5 0 0 1 .708 0L14.293 6.5l1.414-1.414a.5.5 0 0 1 .708.708L15 7.207l1.414 1.414a.5.5 0 0 1-.708.708L14.293 7.914l-1.414 1.414a.5.5 0 0 1-.708-.708L13.586 7.207l-1.414-1.414a.5.5 0 0 1 0-.708z" /></svg>);
const PersonCheckIcon = ({ className = '' }) => (<svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M15.854 5.146a.5.5 0 0 0-.708 0L13.5 6.793l-.646-.647a.5.5 0 0 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0 0-.708z"/><path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/><path d="M6 9a5 5 0 0 0-4.546 2.916C.865 13.1 1.797 14 3 14h7c1.203 0 2.135-.9 1.546-2.084A5 5 0 0 0 7 9H6z"/></svg>);
const SortUpIcon = () => <span className="ms-1 small">▲</span>;
const SortDownIcon = () => <span className="ms-1 small">▼</span>;
const CreditCardIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z" /></svg>;
const ArrowRepeatIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" /><path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" /></svg>;
const ReceiptIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M4 1.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-3zm0-1A1.5 1.5 0 0 0 2.5 1.5v3A1.5 1.5 0 0 0 4 4.5h7A1.5 1.5 0 0 0 12.5 3v-1.5A1.5 1.5 0 0 0 11 0H4z" /><path fillRule="evenodd" d="M2.5 6a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V6zm1 0v7h9V6H3.5z" /><path d="M4 8.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1z" /></svg>;
const ListIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M2.5 3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" /></svg>;
const ShieldGearIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 0c-.69.574-1.6.862-2.5 1.154C4.35 1.529 3.21 1.9 2 2.6v4.9c0 3.2 1.8 6.1 4.7 7.5l1.3.6 1.3-.6c.973-.468 1.82-1.127 2.5-1.92V10.9a3.1 3.1 0 0 1 1.8-2.8V2.6c-1.21-.7-2.35-1.071-3.5-1.446C9.2.862 8.29.574 8 0Zm0 1.121c.566.382 1.249.604 1.91.819 1.04.338 2.104.683 3.19 1.29v4.262a3.08 3.08 0 0 0-.6-.059 3.1 3.1 0 0 0-3.1 3.1c0 1.17.648 2.19 1.604 2.717a8.74 8.74 0 0 1-2.014 1.383L8 15.08l-.99-.447C4.504 13.425 2.9 10.633 2.9 7.5V3.23c1.086-.607 2.15-.952 3.19-1.29.661-.215 1.344-.437 1.91-.82Z"/><path d="M12.5 8a2.5 2.5 0 1 0 1.54 4.47l1.23 1.23a.5.5 0 0 0 .71-.71l-1.16-1.16A2.5 2.5 0 0 0 12.5 8Zm0 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/></svg>;
const PersonPlusIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fillRule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/></svg>);

function ManagementList({
  title,
  data,
  columns,
  addNewLink,
  onSync, // <-- NEW Prop for Sync Action
  editLinkBase,
  onDelete,
  onDeactivate,
  onReactivate,
  disabled,
  onSettings,
  onManageCards,
  onAssignPatients,
  shouldShowAssignPatients,
  onViewTransactions, // <-- NEW Prop for Transactions
  shouldShowManageCards,
  isServerSide = false,
  isLoading = false,
  serverPage = 1,
  serverTotalPages = 1,
  serverCounts = null,
  onPageChange,
  onTabChange,
  onSearch,
  // --- New Sort Props ---
  onSort,
  sortConfig = { key: null, direction: 'asc' },

  hiddenTabs = [],
  customTabs = null,
  customFilter = null,
  limit,
  handleLimitChange,
  showSearchFilterBtn = false,
  showSearchBar = true,
  deactivationType,
  canCreate,
  canUpdate,
  canDeactivate,
  canReactivate,
  canViewPayment,
  canViewTransactions,
  canViewRoles,
  onManageRolesPermissions,
  openFiltersModal,
  onExport,
  exportTooltip = 'Export report',
  exportDisabled = false,
  isAdminDeactivateDisabled,
  canExport,
  onBulkAssignCaseManager,
  bulkGroupByField = 'clientName',
}) {
  const SEARCH_DEBOUNCE_MS = 500;
  const isAdminUsersScreen = title === "Admin Users";
  const [activeTab, setActiveTab] = useState(customTabs && customTabs.length > 0 ? customTabs[0].eventKey : STATUS.ACTIVE);
  const [searchTerm, setSearchTerm] = useState('');
  const [clientPage, setClientPage] = useState(1);
  const itemsPerPage = 20 
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [itemToProcess, setItemToProcess] = useState(null);
  const [deactivationReason, setDeactivationReason] = useState('');
  const [reasonError, setReasonError] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [bulkInfoModal, setBulkInfoModal] = useState({ show: false, message: '', type: 'info' });
  const [showReassignModal, setShowReassignModal] = useState(false);
  const searchDebounceTimeoutRef = useRef(null);
  const searchFieldOptions = useMemo(() => {
    const options = [];

    (columns || [])
      .filter((col) => col?.accessor
        && col.accessor !== 'action'
        && col.accessor !== 'simStatus'
        && col.accessor !== 'iccidDisplay'
        && col.accessor !== 'enrollmentDate'
        && col.accessor !== 'msisdn'
        && col.accessor !== 'deactivationDate'
        && col.accessor !== 'deactivationReason'
        && col.accessor !== 'deactivatedAt'
        && col.accessor !== 'raw_deactivatedAt')
      .forEach((col) => {
        const valueKey = col.accessor === 'idLink'
          ? (data?.some((item) => item?.recordId != null) ? 'recordId' : 'id')
          : col.accessor;
        const payloadKey = col.searchKey || valueKey;
        const label = typeof col.header === 'string' ? col.header : valueKey;
        if (!valueKey || !payloadKey || options.some((opt) => opt.valueKey === valueKey)) return;
        options.push({ valueKey, payloadKey, label });
      });

    return options;
  }, [columns, data]);

  const idFieldKey = useMemo(
    () => {
      const exactIdOption = searchFieldOptions.find((opt) => {
        const normalizedLabel = String(opt.label || '').trim().toLowerCase();
        const normalizedValueKey = String(opt.valueKey || '').trim().toLowerCase();
        return normalizedLabel === 'id' || ['id', 'recordid', 'record_id', 'idlink'].includes(normalizedValueKey);
      });
      if (exactIdOption) return exactIdOption.valueKey;
      return searchFieldOptions.find((opt) => /(id)/i.test(opt.label) || /(id)/i.test(opt.valueKey))?.valueKey || null;
    },
    [searchFieldOptions],
  );
  const nameFieldKey = useMemo(
    () => searchFieldOptions.find((opt) => /(name)/i.test(opt.label) || /(name)/i.test(opt.valueKey))?.valueKey || null,
    [searchFieldOptions],
  );
  const imeiFieldKey = useMemo(
    () => searchFieldOptions.find((opt) => /(imei)/i.test(opt.label) || /(imei)/i.test(opt.valueKey))?.valueKey || null,
    [searchFieldOptions],
  );
  const caseManagerFieldKey = useMemo(
    () => searchFieldOptions.find((opt) => /(case\s*manager)/i.test(opt.label) || /(casemanager|case_manager)/i.test(opt.valueKey))?.valueKey || null,
    [searchFieldOptions],
  );

  const defaultSelectedFieldKeys = useMemo(() => {
    const defaults = [idFieldKey, nameFieldKey].filter(Boolean);
    if (defaults.length > 0) return defaults;
    if (searchFieldOptions.length > 0) return [searchFieldOptions[0].valueKey];
    return [];
  }, [idFieldKey, nameFieldKey, searchFieldOptions]);

  const [selectedSearchFields, setSelectedSearchFields] = useState(defaultSelectedFieldKeys);

  useEffect(() => {
    if (searchFieldOptions.length === 0) {
      setSelectedSearchFields([]);
      return;
    }
    setSelectedSearchFields((prev) => {
      const valid = (prev || []).filter((key) => searchFieldOptions.some((opt) => opt.valueKey === key));
      if (imeiFieldKey && valid.includes(imeiFieldKey)) {
        return [imeiFieldKey];
      }
      const merged = [...valid];
      defaultSelectedFieldKeys.forEach((key) => {
        if (!merged.includes(key)) merged.push(key);
      });
      return merged.length > 0 ? merged : defaultSelectedFieldKeys;
    });
  }, [searchFieldOptions, defaultSelectedFieldKeys, imeiFieldKey]);

  const getPayloadSearchFields = (selectedValueKeys = selectedSearchFields) => {
    const payloadKeys = selectedValueKeys
      .map((valueKey) => searchFieldOptions.find((opt) => opt.valueKey === valueKey)?.payloadKey)
      .filter(Boolean);
    return [...new Set(payloadKeys)];
  };

  const triggerServerSearch = (term, selectedValueKeys) => {
    if (searchDebounceTimeoutRef.current) {
      clearTimeout(searchDebounceTimeoutRef.current);
      searchDebounceTimeoutRef.current = null;
    }
    if (isServerSide && onSearch) {
      onSearch(term, getPayloadSearchFields(selectedValueKeys));
    }
  };

  const triggerServerSearchDebounced = (term, selectedValueKeys) => {
    if (!isServerSide || !onSearch) return;
    if (searchDebounceTimeoutRef.current) {
      clearTimeout(searchDebounceTimeoutRef.current);
    }
    searchDebounceTimeoutRef.current = setTimeout(() => {
      onSearch(term, getPayloadSearchFields(selectedValueKeys));
      searchDebounceTimeoutRef.current = null;
    }, SEARCH_DEBOUNCE_MS);
  };

  useEffect(
    () => () => {
      if (searchDebounceTimeoutRef.current) {
        clearTimeout(searchDebounceTimeoutRef.current);
      }
    },
    [],
  );

  let displayData = [];
  let currentPage = 1;
  let totalPages = 1;

  const normalizeStatus = (status) => {
    if (!status) return '';
    const s = String(status).toLowerCase();
    if (s === 'a' || s === STATUS.ACTIVE) return STATUS.ACTIVE;
    if (s === 'r' || s === STATUS.PENDING) return STATUS.PENDING;
    if (s === 'd' || s === STATUS.DEACTIVATED) return STATUS.DEACTIVATED;
    return s;
  };

  const doesItemMatchSearch = (item) => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return true;

    const keysToSearch = selectedSearchFields.length > 0 ? selectedSearchFields : defaultSelectedFieldKeys;
    if (keysToSearch.length === 0) return true;

    return keysToSearch.some((key) => {
      const value = item?.[key];
      if (value === null || value === undefined || React.isValidElement(value)) return false;
      return String(value).toLowerCase().includes(term);
    });
  };

  const handleToggleSearchField = (fieldKey, checked) => {
    const isImeiField = imeiFieldKey && fieldKey === imeiFieldKey;
    const pinnedDefaults = defaultSelectedFieldKeys;

    setSelectedSearchFields((prev) => {
      const current = prev || [];
      const isChecked = current.includes(fieldKey);
      const nextChecked = checked ?? !isChecked;

      if (isImeiField) {
        const next = nextChecked ? [fieldKey] : (pinnedDefaults.length > 0 ? pinnedDefaults : current);
        const nextSearchTerm = nextChecked ? '' : searchTerm;
        if (nextChecked) setSearchTerm('');
        triggerServerSearch(nextSearchTerm, next);
        return next;
      }

      if (nextChecked) {
        const withoutImei = imeiFieldKey ? current.filter((k) => k !== imeiFieldKey) : [...current];
        const next = withoutImei.includes(fieldKey) ? withoutImei : [...withoutImei, fieldKey];
        // ID and Name stay selected until IMEI is selected.
        pinnedDefaults.forEach((defaultKey) => {
          if (!next.includes(defaultKey)) next.push(defaultKey);
        });
        triggerServerSearch(searchTerm, next);
        return next;
      }

      if (pinnedDefaults.includes(fieldKey) && !(imeiFieldKey && current.includes(imeiFieldKey))) {
        return current;
      }

      const next = current.filter((k) => k !== fieldKey);
      const normalized = next.length > 0 ? next : pinnedDefaults;
      triggerServerSearch(searchTerm, normalized);
      return normalized;
    });
  };

  const visibleSearchFieldOptions = searchFieldOptions;
  const isImeiSearchSelected = Boolean(
    imeiFieldKey && selectedSearchFields.includes(imeiFieldKey),
  );
  const toggleRowSelection = (item) => {
    setSelectedRows((prev) => {
      const exists = prev.some((r) => r.id === item.id);
      return exists ? prev.filter((r) => r.id !== item.id) : [...prev, item];
    });
  };

  const toggleSelectAll = (items) => {
    const allSelected = items.every((item) => selectedRows.some((r) => r.id === item.id));
    if (allSelected) {
      setSelectedRows((prev) => prev.filter((r) => !items.some((item) => item.id === r.id)));
    } else {
      setSelectedRows((prev) => {
        const merged = [...prev];
        items.forEach((item) => {
          if (!merged.some((r) => r.id === item.id)) merged.push(item);
        });
        return merged;
      });
    }
  };

  const handleBulkAssignClick = () => {
    if (selectedRows.length === 0) {
      setBulkInfoModal({ show: true, type: 'info', message: 'Select one or more device users to case manager assignment.' });
      return;
    }
    if (bulkGroupByField) {
      const uniqueValues = new Set(selectedRows.map((r) => r[bulkGroupByField]));
      if (uniqueValues.size > 1) {
        setBulkInfoModal({ show: true, type: 'warning', message: 'Device users can only be selected together if they have the same client and case manager.' });
        return;
      }
    }
    setShowReassignModal(true);
    onBulkAssignCaseManager?.(selectedRows);
  };

  const orderedSearchFieldOptions = useMemo(() => {
    const preferredOrder = [idFieldKey, nameFieldKey, imeiFieldKey, caseManagerFieldKey, ...defaultSelectedFieldKeys].filter(Boolean);
    const ordered = [];

    preferredOrder.forEach((key) => {
      const found = visibleSearchFieldOptions.find((opt) => opt.valueKey === key);
      if (found && !ordered.some((opt) => opt.valueKey === found.valueKey)) ordered.push(found);
    });

    visibleSearchFieldOptions.forEach((opt) => {
      if (!ordered.some((o) => o.valueKey === opt.valueKey)) ordered.push(opt);
    });

    return ordered;
  }, [visibleSearchFieldOptions, idFieldKey, nameFieldKey, imeiFieldKey, caseManagerFieldKey, defaultSelectedFieldKeys]);
  const shouldShowSearchControls = showSearchBar || showSearchFilterBtn;

  let counts = {};

  if (isServerSide && serverCounts) {
    counts = serverCounts;
  } else {
    if (customTabs) {
      customTabs.forEach(tab => {
        counts[tab.eventKey] = data?.filter(item => customFilter ? customFilter(item, tab.eventKey) : true).length;
      });
    } else {
      const countByStatus = (statusKey) => data?.filter(item => normalizeStatus(item.status) === statusKey).length;
      counts = {
        active: countByStatus('active'),
        pending: countByStatus('pending'),
        deactivated: countByStatus('deactivated')
      };
    }
  }

  if (isServerSide) {
    displayData = data;
    currentPage = serverPage;
    totalPages = serverTotalPages;
  } else {
    const filtered = data.filter(item => {
      let matchesTab = true;
      if (customTabs && customFilter) {
        matchesTab = activeTab === 'all' || customFilter(item, activeTab);
      } else {
        const hasStatus = Object.prototype.hasOwnProperty.call(item, 'status');
        const itemStatusKey = normalizeStatus(item.status);
        matchesTab = !hasStatus || activeTab === 'all' || itemStatusKey === activeTab;
      }

      const matchesSearch = doesItemMatchSearch(item);

      return matchesTab && matchesSearch;
    });

    const lastIndex = clientPage * itemsPerPage;
    const firstIndex = lastIndex - itemsPerPage;
    displayData = filtered.slice(firstIndex, lastIndex);
    currentPage = clientPage;
    totalPages = Math.ceil(filtered.length / itemsPerPage);
  }

  const visibleData = isServerSide ? displayData : displayData.filter(doesItemMatchSearch);

  const handlePageChange = (p) => {
    if (isServerSide) { if (onPageChange) onPageChange(p); } else { setClientPage(p); }
  };

  const handleTabSelect = (k) => {
    setActiveTab(k);
    if (isServerSide) { if (onPageChange) onPageChange(1); if (onTabChange) onTabChange(k); } else { setClientPage(1); }
  };

  const handleSearch = (e) => {
    const rawTerm = e.target.value;
    const term = isImeiSearchSelected ? rawTerm.replace(/\D/g, '') : rawTerm;
    setSearchTerm(term);
    if (isServerSide) {
      triggerServerSearchDebounced(term, selectedSearchFields);
    } else {
      setClientPage(1);
    }
  };

  const handleHeaderClick = (col) => {
    if (onSort && col.sortable) {
      // Use sortKey if available (for API field name), else accessor
      onSort(col.sortKey || col.accessor);
    }
  };

  const handleShowDeleteModal = (item) => { setItemToProcess(item); setShowDeleteModal(true); };
  const handleCloseDeleteModal = () => { setShowDeleteModal(false); setItemToProcess(null); };
  const handleConfirmDelete = () => { if (itemToProcess && onDelete) onDelete(itemToProcess.id); handleCloseDeleteModal(); };

  const handleShowDeactivateModal = (item) => {
    setItemToProcess(item); setDeactivationReason('');
    setShowDeactivateModal(true);
  };
  const handleCloseDeactivateModal = () => { setShowDeactivateModal(false); setItemToProcess(null); };

  const handleConfirmDeactivate = async () => {
    // Validation Logic
    if (!deactivationReason.trim()) {
      setReasonError('Reason is required for deactivation.');
      return;
    }

    if (itemToProcess && onDeactivate) {
      const shouldClose = await onDeactivate(itemToProcess.id, deactivationReason);
      if (shouldClose === false) return;
    }
    handleCloseDeactivateModal();
  };

  const isTabVisible = (key) => !hiddenTabs.includes(key);

  const getDefaultTabs = () => {
    const allTabs = [
      { key: STATUS.ACTIVE, title: `Active (${counts.active || 0})` },
      { key: STATUS.PENDING, title: `Pending (${counts.registered || counts.pending || 0})` },
      { key: STATUS.DEACTIVATED, title: `Deactivated (${counts.deactivated || 0})` },
      // { key: 'all', title: `All (${totalCount})` }
    ];
    return allTabs.filter(t => isTabVisible(t.key));
  };

  const canShowReactivateAction = Boolean(
    onReactivate && (typeof canReactivate === 'boolean' ? canReactivate : canDeactivate),
  );

  const visibleColumns = (columns || []).filter((col) => {
    if (col.hidden) return false;
    if (Array.isArray(col.visibleOnTabs) && !col.visibleOnTabs.includes(activeTab)) {
      return false;
    }

    if (activeTab === STATUS.DEACTIVATED && !canShowReactivateAction && col.accessor === 'action') {
      return false;
    }

    return true;
  });

  const getActionItems = (item) => {
    const items = [];
    if (onSync) {
      items.push({
        key: 'sync',
        label: 'Sync SIM',
        icon: <ArrowRepeatIcon />,
        className: 'text-success',
        onClick: () => onSync(item),
        priority: 30
      });
    }
    if (
      onAssignPatients &&
      activeTab !== STATUS.DEACTIVATED &&
      (shouldShowAssignPatients ? shouldShowAssignPatients(item) : true)
    ) {
      items.push({
        key: 'assignPatients',
        label: 'Assign Device Users',
        icon: <PersonPlusIcon />,
        className: 'text-primary',
        onClick: () => onAssignPatients(item),
        priority: 5
      });
    }
    if (editLinkBase && canUpdate && activeTab !== STATUS.DEACTIVATED && !isAdminDeactivateDisabled(item)) {
      items.push({
        key: 'edit',
        label: 'Edit',
        icon: <PencilSquareIcon />,
        className: 'text-primary',
        to: `${editLinkBase}/${item.id}`,
        priority: 10
      });
    }
    if (onViewTransactions && canViewTransactions) {
      items.push({
        key: 'transactions',
        label: 'View Transactions',
        icon: <ReceiptIcon />,
        className: 'text-secondary',
        onClick: () => onViewTransactions(item),
        priority: 50
      });
    }
    if (onManageCards && canViewPayment && (shouldShowManageCards ? shouldShowManageCards(item) : true)) {
      items.push({
        key: 'cards',
        label: 'View Payment Methods',
        icon: <CreditCardIcon />,
        className: 'text-info',
        onClick: () => onManageCards(item),
        priority: 60
      });
    }
    if (onSettings) {
      items.push({
        key: 'settings',
        label: 'Settings',
        icon: <GearIcon />,
        className: 'text-secondary',
        onClick: () => onSettings(item),
        priority: 40
      });
    }
    if (activeTab === STATUS.DEACTIVATED && canShowReactivateAction) {
      items.push({
        key: 'reactivate',
        label: 'Reactivate',
        icon: <PersonCheckIcon />,
        className: 'text-success',
        onClick: () => onReactivate(item.id),
        priority: 20
      });
    }
    if (activeTab !== STATUS.DEACTIVATED && activeTab !== STATUS.PENDING && onDeactivate && canDeactivate && !isAdminDeactivateDisabled(item)) {
      items.push({
        key: 'deactivate',
        label: 'Deactivate',
        icon: <PersonXIcon className="management-list__deactivate-icon" />,
        className: 'text-danger',
        disabled: typeof disabled === 'function' ? disabled(item) : false,
        onClick: () => handleShowDeactivateModal(item),
        priority: 20
      });
    }
    if (onDelete) {
      items.push({
        key: 'delete',
        label: 'Delete',
        icon: <TrashIcon />,
        className: 'text-danger',
        onClick: () => handleShowDeleteModal(item),
        priority: 70
      });
    }
    return items.sort((a, b) => (a.priority || 999) - (b.priority || 999));
  };

  const renderActionControl = (action, idSuffix) => (
    <OverlayTrigger
      key={`${action.key}-${idSuffix}`}
      placement="top"
      overlay={<Tooltip>{action.label}</Tooltip>}
    >
      <Button
        as={action.to ? Link : 'button'}
        to={action.to}
        onClick={action.onClick}
        disabled={Boolean(action.disabled)}
        variant="link"
        size="sm"
        className={`p-0 border-0 shadow-none management-list__inline-action-btn ${action.className || ''}`}
      >
        {action.icon}
      </Button>
    </OverlayTrigger>
  );

  return (
    <Container fluid className="px-0">
      <Row className="mb-3">
        <Col>
          <div className="bg-white shadow-sm p-3 rounded d-flex align-items-center justify-content-between gap-2">
            <h1 className="h3 mb-0 text-primary">{title}</h1>
            {title === "Device Users" && <p className="mb-0 text-muted management-list__search-note">
              <span className="fw-semibold">Note:</span> Selecting IMEI will
              unselect the other checkboxes.
            </p>}
            {onManageRolesPermissions && canViewRoles && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Manage Roles & Permissions</Tooltip>}
              >
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={onManageRolesPermissions}
                  className="d-inline-flex align-items-center gap-1"
                >
                  <ShieldGearIcon /> Manage Roles & Permissions
                </Button>
              </OverlayTrigger>
            )}
            {openFiltersModal && (
              <Button
                variant="outline-primary"
                size="sm"
                onClick={openFiltersModal}
                className="d-inline-flex align-items-center gap-1"
              >
                Run Your Report
              </Button>
            )}
          </div>
        </Col>
      </Row>

      <div className="bg-white shadow-sm rounded overflow-visible">
        <div className="p-3">
          <Row className="align-items-center gy-2">
            <Col xs={12} md={6}>
              <Tabs
                id={`${title}-tabs`}
                activeKey={activeTab}
                onSelect={handleTabSelect}
                className="mb-0 nav-tabs-allwell management-list__tabs"
              >
                {customTabs
                  ? customTabs.map((tab) => (
                      <Tab
                        key={tab.eventKey}
                        eventKey={tab.eventKey}
                        title={`${tab.title} (${counts[tab.eventKey] || 0})`}
                      />
                    ))
                  : getDefaultTabs().map((tab) => (
                      <Tab key={tab.key} eventKey={tab.key} title={tab.title} />
                    ))}
              </Tabs>
            </Col>
            <Col xs="auto">
              <FilterDropdown
                label="Limit"
                options={LIMIT}
                value={limit}
                onChange={handleLimitChange}
              />
            </Col>

            <Col
              xs={12} sm="auto"
              className="d-flex justify-content-start justify-content-sm-end align-items-center gap-2 flex-wrap ms-sm-auto"
            >
              {onBulkAssignCaseManager && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      Manage Device User Reassignment
                    </Tooltip>
                  }
                >
                  <Button
                    variant={selectedRows.length > 0 ? 'primary' : 'outline-secondary'}
                    size="sm"
                    onClick={handleBulkAssignClick}
                    className="d-inline-flex align-items-center gap-2 position-relative"
                    aria-label="Manage Device User Reassignment"
                  >
                    <FontAwesomeIcon icon={faUserTag} />
                    <span className="d-none d-md-inline">Manage Device User Reassignment</span>
                    {selectedRows.length > 0 && (
                      <span
                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                        style={{ fontSize: '0.6rem' }}
                      >
                        {selectedRows.length}
                      </span>
                    )}
                  </Button>
                </OverlayTrigger>
              )}
              {onExport && canExport && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{exportTooltip}</Tooltip>}
                >
                  <Button
                    variant="light"
                    size="sm"
                    onClick={onExport}
                    disabled={Boolean(exportDisabled)}
                    // className="d-inline-flex align-items-center justify-content-center"
                    aria-label={exportTooltip}
                  >
                   <img src={'/images/excelImage.png'} alt="ExportExcelIcon" style={{width: '36px', height: '26px'}} />
                  </Button>
                </OverlayTrigger>
              )}
              <Pagination size="sm" className="my-0">
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1 || isLoading}
                />
                <Pagination.Item active>{currentPage}</Pagination.Item>
                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages || isLoading}
                />
              </Pagination>

              {!showSearchFilterBtn && shouldShowSearchControls && (
                <InputGroup className="w-auto">
                  <Form.Control
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearch}
                    inputMode={isImeiSearchSelected ? 'numeric' : 'text'}
                    size="sm"
                    style={{ minWidth: "180px" }}
                  />
                  <InputGroup.Text className="bg-primary text-white">
                    <SearchIcon />
                  </InputGroup.Text>
                </InputGroup>
              )}

              {addNewLink && canCreate && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Add New Record</Tooltip>}
                >
                  <Button
                    as={Link}
                    to={addNewLink}
                    variant="primary"
                    size="sm"
                    className="d-flex align-items-center gap-1"
                  >
                    <PlusCircleIcon /> Add New
                  </Button>
                </OverlayTrigger>
              )}
            </Col>
          </Row>

          {showSearchFilterBtn && (
            <Row className="mt-3">
              <Col
                md={12}
                className="d-flex justify-content-start align-items-center flex-wrap management-list__search-row"
              >
                <InputGroup className="w-auto management-list__search-input-group">
                  <Form.Control
                    placeholder="Search by ID, Name, Email, or IMEI..."
                    value={searchTerm}
                    onChange={handleSearch}
                    inputMode={isImeiSearchSelected ? 'numeric' : 'text'}
                    size="sm"
                    style={{ minWidth: "340px" }}
                  />
                  <InputGroup.Text className="bg-primary text-white">
                    <SearchIcon />
                  </InputGroup.Text>
                </InputGroup>

                <div className="d-flex align-items-center flex-wrap management-list__search-scope">
                  <span className="small text-muted fw-semibold mb-0">
                    Search in:
                  </span>
                  {orderedSearchFieldOptions.map((field) => (
                    <Form.Check
                      inline
                      key={field.valueKey}
                      type="checkbox"
                      id={`search-field-${field.valueKey}`}
                      label={field.label}
                      checked={selectedSearchFields.includes(field.valueKey)}
                      onChange={(e) =>
                        handleToggleSearchField(
                          field.valueKey,
                          e.target.checked,
                        )
                      }
                      className="mb-0 management-list__search-scope-item"
                    />
                  ))}
                </div>
              </Col>
            </Row>
          )}
        </div>

        <div className="management-list__table-wrap">
          <Table responsive hover className="mb-0">
            <thead className="bg-light">
              <tr>
                {onBulkAssignCaseManager && (
                  <th style={{ width: '36px' }}>
                    <Form.Check
                      type="checkbox"
                      aria-label="Select all visible rows"
                      checked={visibleData?.length > 0 && visibleData.every((item) => selectedRows.some((r) => r.id === item.id))}
                      onChange={() => toggleSelectAll(visibleData || [])}
                    />
                  </th>
                )}
                {visibleColumns.map((col) => (
                  <th
                    key={col.accessor}
                    onClick={() => handleHeaderClick(col)}
                    style={{
                      cursor: col.sortable && onSort ? "pointer" : "default",
                      whiteSpace: "nowrap",
                      ...(col.minWidth ? { minWidth: col.minWidth } : {}),
                    }}
                    className="text-start"
                  >
                    <div className="d-flex align-items-center justify-content-start">
                      {col.header}
                      {col.sortable && onSort && (
                        <span className="text-muted ms-1">
                          {sortConfig.key === (col.sortKey || col.accessor) ? (
                            sortConfig.direction === "asc" ? (
                              <SortUpIcon />
                            ) : (
                              <SortDownIcon />
                            )
                          ) : (
                            // Neutral state or placeholder
                            <span style={{ opacity: 0.8, fontSize: "0.7rem" }}>
                              ⇅
                            </span>
                          )}
                        </span>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td
                    colSpan={visibleColumns.length + (onBulkAssignCaseManager ? 1 : 0)}
                    className="text-center py-5"
                  >
                    <Spinner animation="border" variant="primary" />
                  </td>
                </tr>
              ) : visibleData?.length > 0 ? (
                visibleData?.map((item, idx) => (
                  <tr
                    key={item.id || idx}
                    className={onBulkAssignCaseManager && selectedRows.some((r) => r.id === item.id) ? 'table-primary' : ''}
                  >
                    {onBulkAssignCaseManager && (
                      <td style={{ width: '36px' }} onClick={(e) => e.stopPropagation()}>
                        <Form.Check
                          type="checkbox"
                          aria-label="Select row"
                          checked={selectedRows.some((r) => r.id === item.id)}
                          onChange={() => toggleRowSelection(item)}
                        />
                      </td>
                    )}
                    {visibleColumns.map((col) => (
                      <td
                        key={col.accessor}
                        className="text-start"
                        style={{
                          whiteSpace: 'nowrap',
                          ...(col.minWidth ? { minWidth: col.minWidth } : {}),
                        }}
                      >
                        {col.accessor === "action" ? (
                          <div className="d-flex justify-content-start">
                            {(() => {
                              const actions = getActionItems(item);
                              const inlineActions = actions.slice(0, 2);
                              const overflowActions = actions.slice(2);
                              const itemId = item.id || idx;

                              return (
                                <div className={`d-flex align-items-center gap-2 management-list__actions-wrap ${isAdminUsersScreen ? "management-list__actions-wrap--admin-users" : ""}`}>
                                  {inlineActions.map((action) =>
                                    renderActionControl(action, itemId),
                                  )}
                                  {overflowActions.length > 0 && (
                                    <Dropdown align="end" drop="start">
                                      <Dropdown.Toggle
                                        variant="link"
                                        size="sm"
                                        className={`p-0 text-secondary border-0 shadow-none management-list__action-toggle ${isAdminUsersScreen ? "management-list__action-toggle--admin-users" : ""}`}
                                        id={`action-menu-${itemId}`}
                                      >
                                        <ListIcon />
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu
                                        className="management-list__action-menu"
                                        popperConfig={{
                                          modifiers: [
                                            {
                                              name: "offset",
                                              options: { offset: [0, 6] },
                                            },
                                          ],
                                        }}
                                      >
                                        {overflowActions.map((action) => (
                                          <Dropdown.Item
                                            key={action.key}
                                            as={action.to ? Link : "button"}
                                            to={action.to}
                                            onClick={action.onClick}
                                            disabled={Boolean(action.disabled)}
                                            className={`d-flex align-items-center gap-2 management-list__action-item ${action.className || ""}`}
                                          >
                                            {action.icon}
                                            <span>{action.label}</span>
                                          </Dropdown.Item>
                                        ))}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  )}
                                </div>
                              );
                            })()}
                          </div>
                        ) : typeof col.render === "function" ? (
                          col.render(item)
                        ) : (
                          item[col.accessor]
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={visibleColumns.length + (onBulkAssignCaseManager ? 1 : 0)}
                    className="text-center text-muted py-4"
                  >
                    No items found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this item? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            className="border"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Bulk Assign Info Modal */}
      <Modal
        show={bulkInfoModal.show}
        onHide={() => setBulkInfoModal({ show: false, message: '', type: 'info' })}
        centered
      >
        <Modal.Body className="text-center px-4 pt-4 pb-3">
          <div
            className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
            style={{
              width: 64,
              height: 64,
              backgroundColor: bulkInfoModal.type === 'warning' ? '#fff3cd' : '#e8f2ff',
            }}
          >
            <FontAwesomeIcon
              icon={bulkInfoModal.type === 'warning' ? faTriangleExclamation : faCircleInfo}
              style={{
                fontSize: '1.75rem',
                color: bulkInfoModal.type === 'warning' ? '#e67e22' : '#0d6efd',
              }}
            />
          </div>
          <h5 className="fw-semibold mb-2">
            {bulkInfoModal.type === 'warning' ? 'Selection Invalid' : 'Manage Device User Reassignment'}
          </h5>
          <p className="text-muted mb-0" style={{ fontSize: '0.9rem', lineHeight: 1.55 }}>
            {bulkInfoModal.message}
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0 pt-0 pb-3">
          <Button
            variant={bulkInfoModal.type === 'warning' ? 'warning' : 'primary'}
            className="px-4"
            onClick={() => setBulkInfoModal({ show: false, message: '', type: 'info' })}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Deactivate Modal */}
      <Modal
        size="lg"
        show={showDeactivateModal}
        onHide={handleCloseDeactivateModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deactivation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{`Are you sure you want to deactivate this ${deactivationType}?`}</p>
          <Form.Group className="mt-3">
            <Form.Label>Reason for Deactivation *</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={deactivationReason}
              onChange={(e) => {
                setDeactivationReason(e.target.value);
                if (e.target.value.trim()) setReasonError("");
              }}
              placeholder="Enter reason..."
              isInvalid={!!reasonError}
            />
            <Form.Control.Feedback type="invalid">
              {reasonError}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            className="border"
            onClick={handleCloseDeactivateModal}
          >
            Cancel
          </Button>
          <Button
            variant="warning"
            className="text-white"
            onClick={handleConfirmDeactivate}
          >
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      <PatientReassignmentModal
        show={showReassignModal}
        onHide={() => {
          setShowReassignModal(false);
          setSelectedRows([]);
        }}
        patients={selectedRows}
      />
    </Container>
  );
}

export default ManagementList;